import { render, staticRenderFns } from "./SeriesRaceColumnTbl.vue?vue&type=template&id=1caa775e&"
import script from "./SeriesRaceColumnTbl.vue?vue&type=script&lang=js&"
export * from "./SeriesRaceColumnTbl.vue?vue&type=script&lang=js&"
import style0 from "./SeriesRaceColumnTbl.vue?vue&type=style&index=0&id=1caa775e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports